import { GenericFormType, GenericFormButtonType, GenericForm } from 'components/forms/GenericForm';
import { LayoutContainer, LeftSideBar } from 'components/layout';
import React from 'react';
import { StepperLabelHorizontal, StepperLabelVertical } from './components';
import useStepper from './hooks/useStepper';
import './style/stepper.scss';

/**
 *  Render a step of form. You just need to pass an array of generic-form
 */
export const Stepper: React.FC<IStepper> = (props: IStepper) => {


    const {
        stepIndex,
        stepUnlocked,
        stepIndexSubmiting,
        step, 
        handleFormSubmit,
        handleBack,
        handleScroll,
        handleLabelClick,
        divsRef,
        layoutContainerRef
    } = useStepper(props);

    const render_form = (step: StepType, index: number) => {
        return (
            <GenericForm 
                isDirtyUx={props.isDirtyUx}
                {...step}
                defaultValue={props.value || {}}
                onBack={handleBack}
                isLoading={stepIndexSubmiting === index}
                onSubmit={(value?: Record<string, any>) => handleFormSubmit(value, step, index)}
                />
        )
    }

    const render_scroll = () => {
        // Todo : check if all form is valid before validate
        return (
            <div ref={divsRef}>
                {
                    !props.isLastStepCanGoBack && (props.steps.length - 1)  == stepUnlocked 
                    ? render_form(step, props.steps.length - 1)
                    : props.steps.map((step, index) => (
                        index <= stepUnlocked && render_form({
                            ...step,
                            hideFooter: index > stepUnlocked
                        }, index)
                    ))
                }
            </div>
        )
    }
    
    return (
        <div className="step">

            {
                props.layout === 'scroll' &&
                <>
                    <LeftSideBar>
                        <StepperLabelVertical steps={props.steps} stepIndex={stepIndex} onClick={handleLabelClick} />
                    </LeftSideBar>

                    <LayoutContainer onScroll={handleScroll} ref={layoutContainerRef}>
                        { props.layout === 'scroll' && render_scroll() }
                    </LayoutContainer>
                </>
            }

            {
                props.layout === 'next' &&
                <>
                    <StepperLabelHorizontal steps={props.steps} stepIndex={stepIndex} />
                    <div>
                        { render_form(step, stepIndex) }
                    </div>
                </>
            }
            
            
        </div>
    )
}

export type StepType<T=Record<string, any>> = GenericFormType<T> & { 
    /** Step title */
    title: string, 
    /** Step sub-title */
    subTitle?: string,
    /** Step image */
    img?: string,
    /** Step label class */
    labelClass?: string,
}

export type IStepper = { 
    /** Array of step */
    steps: Array<StepType>
    isDirtyUx?: GenericFormType['isDirtyUx']
    fields?: GenericFormType['fields']
    /** Stepper initial value */
    value?: GenericFormType['value']
    /** 
     * Current stepIndex actived.
     * It control the current stepper index
     * Once controlled, undefined value can't be passed
     * It's better to controll the step index from the outside
     */
    stepIndex?: number,
    /** Stepper layout */
    layout?: 'next' | 'scroll',
    /** Button Submit at the end if layout is "scroll" */
    btnSubmit?: GenericFormButtonType,
    /** 
     * Callback when step is about to end
     * If stepIndex is controlled, this callback will never be fired
     * @param Object data result of the step on object key value format
     */
    onStepperEnd?: (value?: Record<string, any>) => void
    onStepSubmit: (value?: Record<string, any>, step?: StepType, stepIndex?: number) => void,
    /** 
     * Callback when button back is clicked
     */
    onStepBack?: (currentStepIndex?: number, nextStepIndex?: number) => void,
    isLastStepCanGoBack?: boolean
}

Stepper.defaultProps = {
    stepIndex: 0,
    layout: 'next'
}
